import { useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

// Value is stored as a plain YYYY-MM-DD string (no timezone), displayed as DD/MM/YYYY.
const parse = (s) => {
  if (!s) return undefined;
  const [y, m, d] = String(s).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return undefined;
  return new Date(y, m - 1, d);
};
const toIso = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
const display = (s) => {
  const dt = parse(s);
  return dt ? `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}/${dt.getFullYear()}` : "";
};

export function UkDatePicker({ value, onChange, min, placeholder = "DD/MM/YYYY", testId, disabled }) {
  const [open, setOpen] = useState(false);
  const selected = parse(value);
  const minDate = parse(min);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} disabled={disabled}
          className="flex w-full items-center justify-between rounded-lg border border-input px-3.5 py-3 text-sm outline-none focus:border-brand disabled:opacity-60">
          <span className={value ? "text-midnight" : "text-muted-foreground"}>{value ? display(value) : placeholder}</span>
          <CalendarIcon className="h-4 w-4 text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={selected} defaultMonth={selected || minDate || new Date()}
          disabled={minDate ? { before: minDate } : undefined}
          onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
